// /app/tablette : activer / désactiver le mode « tablette du magasin » sur CET appareil.
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { isKiosk, setKiosk } from '../../lib/kiosk'
import { clearEmployeeToken } from '../../lib/employeeApi'

export default function KioskSetup() {
  const nav = useNavigate()
  const [on, setOn] = useState(isKiosk())

  function toggle(v: boolean) {
    setKiosk(v)
    setOn(v)
    clearEmployeeToken()
    try { localStorage.removeItem('loginEmployeeId') } catch { /* ignore */ }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-600 to-blue-800 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 space-y-4 text-center">
        <div className="text-4xl">📱</div>
        <h1 className="text-xl font-bold text-gray-900">Tablette du magasin</h1>
        <p className="text-sm text-gray-600">
          Sur cet appareil partagé : chacun choisit son prénom et tape son code, et la personne est
          <strong> déconnectée automatiquement après 2 minutes</strong> sans toucher l’écran.
          Le réglage ne concerne que cet appareil.
        </p>
        <p className={`text-sm font-semibold ${on ? 'text-green-600' : 'text-gray-500'}`}>
          {on ? '✅ Mode tablette ACTIVÉ sur cet appareil' : 'Mode tablette désactivé sur cet appareil'}
        </p>
        {on ? (
          <button onClick={() => toggle(false)} className="w-full py-3 rounded-xl border border-gray-300 text-gray-700 font-semibold">
            Désactiver le mode tablette
          </button>
        ) : (
          <button onClick={() => toggle(true)} className="w-full py-3 rounded-xl bg-blue-600 text-white font-semibold">
            Activer le mode tablette
          </button>
        )}
        <button onClick={() => nav('/app/login')} className="w-full py-3 rounded-xl bg-gray-900 text-white font-semibold">
          Aller à l’écran de connexion
        </button>
      </div>
    </div>
  )
}
